export default __webpack_public_path__ + "static/media/checkmark.491c7c33.svg";